import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import ClassificationMeter from '@components/charts/classificationMeter/index'

import { StatusContainer, ClassificationContainer } from './styles'

const RiskStatus = ({
  risksData, status, onChange, loading, beneficiaryWithCollectionCount
}) => {

  const {
    none, low, medium, high
  } = risksData || 0

  return (
    <StatusContainer>
      <ClassificationContainer>
        <ClassificationMeter
          loading={loading}
          type="highRisk"
          status={status}
          onSelect={onChange}
          value={high}
          maxValue={beneficiaryWithCollectionCount}
        />
        <ClassificationMeter
          loading={loading}
          type="mediumRisk"
          status={status}
          onSelect={onChange}
          value={medium}
          maxValue={beneficiaryWithCollectionCount}
        />
        <ClassificationMeter
          loading={loading}
          type="lowRisk"
          status={status}
          onSelect={onChange}
          value={low}
          maxValue={beneficiaryWithCollectionCount}
        />
        <ClassificationMeter
          loading={loading}
          type="noRisk"
          status={status}
          onSelect={onChange}
          value={none}
          maxValue={beneficiaryWithCollectionCount}
        />
      </ClassificationContainer>

    </StatusContainer>
  )
}

RiskStatus.propTypes = {
  loading: PropTypes.bool,
  risksData: PropTypes.shape({
    none: PropTypes.number,
    medium: PropTypes.number,
    low: PropTypes.number,
    high: PropTypes.number,
  }),
  status: PropTypes.shape({
    noRisk: PropTypes.bool,
    lowRisk: PropTypes.bool,
    mediumRisk: PropTypes.bool,
    highRisk: PropTypes.bool,
  }).isRequired,
  onChange: PropTypes.func.isRequired,
  beneficiaryWithCollectionCount: PropTypes.number,
}

RiskStatus.defaultProps = {
  risksData: null,
  loading: false,
  beneficiaryWithCollectionCount: 0,
}

const mapStateToProps = ({ overview, beneficiary }) => ({
  risksData: overview.risksData,
  beneficiaryWithCollectionCount: beneficiary.beneficiaryWithCollectionCount,
})

export default connect(mapStateToProps, null)(RiskStatus)
